import type { IconType } from 'react-icons';
import {
  HiLifebuoy,
  HiBellAlert,
  HiUserMinus,
  HiStar,
  HiQuestionMarkCircle,
} from 'react-icons/hi2';

import { TicketCategory } from '../../common/enums/TicketCategory';
import { SupportStatus } from '../../common/enums/SupportStatus';

/**
 * Shared styling vocabulary for support tickets, used by the list and
 * details pages. Hues are system tokens: primary green = support/info,
 * secondary amber = attention/in progress, error = destructive,
 * success = positive/resolved, gray = neutral/unknown.
 */

export const categoryStyles: Record<
  TicketCategory,
  { className: string; Icon: IconType }
> = {
  [TicketCategory.SUPPORT]: {
    className:
      'bg-primary-50 text-primary-700 ring-primary-300 dark:bg-primary-900/40 dark:text-primary-100 dark:ring-primary-700',
    Icon: HiLifebuoy,
  },
  [TicketCategory.ALARM_FEEDBACK]: {
    className:
      'bg-secondary-light text-secondary-dark ring-secondary-main/60 dark:bg-secondary-dark/30 dark:text-secondary-light dark:ring-secondary-dark',
    Icon: HiBellAlert,
  },
  [TicketCategory.DELETE_ACCOUNT_FEEDBACK]: {
    className:
      'bg-error-100 text-error-700 ring-error-300 dark:bg-error-900/40 dark:text-error-200 dark:ring-error-700',
    Icon: HiUserMinus,
  },
  [TicketCategory.APP_RATING_FEEDBACK]: {
    className:
      'bg-success-100 text-success-700 ring-success-300 dark:bg-success-900/40 dark:text-success-200 dark:ring-success-700',
    Icon: HiStar,
  },
  [TicketCategory.RELIGIOUS_INQUIRY]: {
    className:
      'bg-purple-50 text-purple-700 ring-purple-300 dark:bg-purple-900/40 dark:text-purple-200 dark:ring-purple-700',
    Icon: HiQuestionMarkCircle,
  },
};

export const unknownCategoryStyle = {
  className:
    'bg-gray-100 text-gray-700 ring-gray-300 dark:bg-gray-800 dark:text-gray-200 dark:ring-gray-600',
  Icon: HiQuestionMarkCircle,
};

export const statusStyles: Record<
  SupportStatus,
  { className: string; borderClass: string }
> = {
  [SupportStatus.NEW]: {
    className:
      'bg-primary-50 text-primary-700 ring-primary-300 dark:bg-primary-900/50 dark:text-primary-100 dark:ring-primary-600',
    borderClass: 'border-primary-500 dark:border-primary-300',
  },
  [SupportStatus.IN_PROGRESS]: {
    className:
      'bg-secondary-light text-secondary-dark ring-secondary-main/60 dark:bg-secondary-dark/40 dark:text-secondary-light dark:ring-secondary-dark',
    borderClass: 'border-secondary-main dark:border-secondary-light',
  },
  [SupportStatus.FIXED]: {
    className:
      'bg-success-100 text-success-700 ring-success-300 dark:bg-success-900/50 dark:text-success-200 dark:ring-success-600',
    borderClass: 'border-success-500 dark:border-success-400',
  },
  [SupportStatus.CANCELLED]: {
    className:
      'bg-gray-200 text-gray-700 ring-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:ring-gray-500',
    borderClass: 'border-gray-400 dark:border-gray-500',
  },
};
